<template>
  <form-group-thux-horizontal
    :validator="validator"
    :label="labelForm | translate"
    :label-cols-sm="labelColsSm"
    :label-cols-lg="labelColsLg"
    :class="classForm"
    :external-errors="externalErrors"
    :disabled="disabled"
  >
    <multiselect-thux
      :class="['state-multiselect', getBorderClass]"
      :disabled="disabled"
      label="text"
      attributetype="autocomplete"
      :value="value"
      :options="options"
      :placeholder="placeholder"
      :customize-option="true"
      :customize-label="true"
      @select="onSelect"
      @clear="onClear"
    >
      <template slot="option" slot-scope="data">
        <div class="state-option">
          <span class="state-chip-swatch" :style="{ backgroundColor: data.item.option.color }"></span>
          <span class="state-option-label">{{ data.item.option.text }}</span>
        </div>
      </template>
      <template slot="singleLabel" slot-scope="data">
        <span
          class="task-state-chip"
          :style="{ backgroundColor: getSelectedColor(data.item.option) }"
        >
          {{ data.item.option.text }}
        </span>
      </template>
    </multiselect-thux>
  </form-group-thux-horizontal>
</template>

<script>
import MultiselectThux from '@/components/MultiselectThux'

export default {
  name: 'TaskStateSelect',
  components: {
    'multiselect-thux': MultiselectThux
  },
  props: {
    validator: {},
    labelForm: { required: true },
    labelColsSm: { default: 2 },
    labelColsLg: { default: 2 },
    classForm: {},
    externalErrors: {},
    disabled: { default: false },
    value: { required: true },
    options: { required: true },
    placeholder: { default: '' }
  },
  data () {
    return {
      isInitValue: true
    }
  },
  computed: {
    getBorderClass () {
      if (!this.isInitValue) {
        if (this.validator && this.validator.$invalid && !this.value) {
          return 'multiselect_with_border_red'
        } else if (this.validator && !this.validator.$invalid && this.value) {
          return 'multiselect_with_border_active'
        }
      }
      return 'multiselect_with_border'
    }
  },
  methods: {
    onSelect (value) {
      this.$set(this, 'isInitValue', false)
      this.$emit('select', value)
    },
    onClear () {
      this.$set(this, 'isInitValue', false)
      this.$emit('clear')
    },
    getSelectedColor (option) {
      if (option && option.color) return option.color
      const match = this.options && this.options.find((o) => o.value === (option && option.value))
      return match && match.color ? match.color : '#6c757d'
    }
  }
}
</script>
